// Help never replaces the screen you were on. Opening Help (Help Centre, User Manual, What's new, Support tickets)
// keeps that screen aside — exactly as it was, with anything typed but not saved — and closing Help (X, Esc,
// "Back to Falcon", or the browser's Back button) puts it back. Going to another page from the main menu closes Help
// and opens that page as usual.
export const isHelpPath = (path: string) => /^\/app\/help(\/|$|\?)/.test(path);

interface Kept { full: string; node: Element; scrollY: number; title: string }
let kept: Kept | null = null;
let scrollBefore = 0;
/** The page's scroll position just before a navigation (navigate() scrolls to the top before rendering). */
export function noteScroll(y: number) { scrollBefore = y; }

/**
 * Called before each page is drawn. Entering Help from another page keeps that page aside; leaving Help for the
 * kept page puts it back (returns true: nothing else to draw); leaving Help for any other page forgets it.
 */
export function beforeRender(prevFull: string, nextFull: string): boolean {
  const root = document.getElementById("root");
  const nextPath = nextFull.split("?")[0];
  if (isHelpPath(nextPath)) {
    const app = root?.firstElementChild;
    if (!kept && prevFull && !isHelpPath(prevFull.split("?")[0]) && app?.classList.contains("app")) {
      root!.removeChild(app);
      kept = { full: prevFull, node: app, scrollY: scrollBefore, title: document.title };
    }
    return false;
  }
  if (!kept) return false;
  const k = kept;
  kept = null;
  if (k.full !== nextFull || !root) return false;
  root.replaceChildren(k.node);
  document.title = k.title;
  document.body.classList.remove("falcon-menu-open", "help-panel-open");
  requestAnimationFrame(() => window.scrollTo(0, k.scrollY));
  return true;
}
/** Where closing Help goes: the page Help was opened from, else the start page. */
export const helpReturnPath = () => kept?.full || "/app";
